"use client";

import { X } from "lucide-react";

interface GiftDialogProps {
  isOpen: boolean;
  onClose: () => void;
  username: string;
}

const GiftDialog = ({ isOpen, onClose, username }: GiftDialogProps) => {
  if (!isOpen) return null;
  
  const gifts = [
    { id: 'gift1', name: 'Rose', icon: '🌹', price: 5 },
    { id: 'gift2', name: 'Heart', icon: '❤️', price: 10 },
    { id: 'gift3', name: 'Diamond', icon: '💎', price: 50 },
    { id: 'gift4', name: 'Crown', icon: '👑', price: 100 },
    { id: 'gift5', name: 'Star', icon: '⭐', price: 25 },
    { id: 'gift6', name: 'Trophy', icon: '🏆', price: 75 }
  ];
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-xs overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold dark:text-white">Send Gift to @{username}</h2>
          <button 
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
          </button>
        </div>
        <div className="p-4 grid grid-cols-3 gap-2 max-h-60 overflow-y-auto scrollbar-hide">
          {gifts.map(gift => (
            <button key={gift.id} className="flex flex-col items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800">
              <div className="text-3xl mb-1">{gift.icon}</div>
              <div className="text-sm font-medium">{gift.name}</div>
              <div className="text-xs text-gray-500">${gift.price}</div>
            </button>
          ))}
        </div>
        <div className="p-4 border-t border-gray-200 dark:border-gray-700">
          <button className="w-full py-2 bg-[#065900] text-white rounded-lg hover:bg-[#054800] transition-colors">
            Send Gift
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiftDialog;
